<!-- 调拨配件历史 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-right">
                <div class="search-name">调出仓库</div>
                <el-select  class="search-item" size="small" v-model="searchData.OutWarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                    <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">调入仓库</div>
                <el-select class="search-item" size="small" v-model="searchData.InWarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                    <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">汽配编码</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.APCode" v-filter-special-char="searchData.APCode" placeholder="汽配编码"></el-input>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="Visible = true">更多条件</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%"  @cell-dblclick="handleDBClick">
                <el-table-column width="100" prop="OutWarehouse" label="调出仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" prop="InWarehouse" label="调入仓库" show-overflow-tooltip></el-table-column>
                <el-table-column width="180px" prop="TOCode" label="调拨单号" ></el-table-column>
                <el-table-column width="180px" prop="APCode" label="配件编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <img src="@/assets/images/deled.png" title="已删" style=" height: 22px;" v-if="scope.row.GoodsState == 1" />
                        {{ scope.row.APCode }}
                    </template>
                </el-table-column>
                <el-table-column prop="GoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="Cate" label="汽配分类" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="Brand" label="汽配品牌" show-overflow-tooltip></el-table-column>
                <el-table-column width="70" prop="Count" label="调拨数" show-overflow-tooltip></el-table-column>
                <el-table-column width="50" prop="Unit" label="单位" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column width="80" prop="State" label="状态">
                    <template slot-scope="scope">
                        <span style="width: 180px; height: 22px;" v-if="scope.row.State == 0" >
                            未提交
                        </span>
                        <span style="width: 180px; height: 22px;" v-if="scope.row.State == 1" >
                            已提交
                        </span>
                        <span style="width: 180px; height: 22px;" v-if="scope.row.State == 4" >
                            已完成
                        </span>
                    </template>
                </el-table-column>
                <el-table-column width="160px" prop="ConfirmTime" v-if="type == 2" label="提交时间" show-overflow-tooltip></el-table-column>
                <el-table-column width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog 
            :close-on-click-modal="false" 
            title="更多查询条件" 
            :visible.sync="Visible" 
            id="search-order-dialog"   
            custom-class="search-item-dialog"
            :modal="false"
            append-to-body v-dialog-drag lock-scroll
            width="400px">
            <div class="dialog-content" v-if="Visible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="调拨单号">
                        <el-input
                            ref="search_0"
                            class="search-item"
                            size="small" 
                            v-model.trim="searchData.OrderCode" 
                            v-filter-special-char="searchData.OrderCode" 
                            placeholder="调拨单号"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="调出仓库">
                         <el-select
                            ref="search_1"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.OutWarehouseId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="调入仓库">
                        <el-select
                            ref="search_2"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.InWarehouseId"
                            filterable
                            clearable 
                            @visible-change="wHVisibleChange($event)">
                            <el-option v-for="optionItem in warehouseList" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配编码">
                        <el-input
                            ref="search_3"
                            class="search-item"
                            size="small" 
                            v-model.trim="searchData.APCode" 
                            v-filter-special-char="searchData.APCode" 
                            placeholder="请输入汽配编码"
                            >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称">
                        <el-select
                            ref="search_4"
                            size="small"
                            class="search-item"
                            v-model="searchData.GoodName"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入配件名称"
                            :remote-method="searchGoodName"
                            v-select-scroll-more="searchGoodNameLoad"
                            popper-class="my-select"
                            style="width: 100%;"
                        >
                            <el-option v-for="item in goodNameOptions" :key="item" :label="item" :value="item"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-select
                            ref="search_5"
                            size="small"
                            class="search-item"
                            v-model="searchData.AutoSerise"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="请输入车型"
                            :remote-method="searchAutoSerise"
                            v-select-scroll-more="searchAutoSeriseLoad"
                            popper-class="my-select"
                            style="width: 100%;"
                        >
                            <el-option v-for="item in autoSeriseOptions" :key="item" :label="item" :value="item" style="width: 300px"> </el-option>
                            <el-option v-if="optionLoading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配分类">
                        <el-select
                            ref="search_6"
                            size="small"
                            style="width: 100%"
                            v-model="searchData.Cate"
                            remote
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌">
                        <el-select
                            ref="search_7"
                            v-model="searchData.BrandName"
                            remote
                            collapse-tags
                            filterable
                            clearable
                            multiple
                            size="small"
                            style="width:100%" 
                            @visible-change="getGoodsBrand($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            ref="search_8"
                            style="width: 100%"
                            size="small"
                            v-model.trim="searchData.Remark"
                            placeholder="请输入备注"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态" v-if="type == 2">
                        <el-select ref="search_9" style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-date-picker
                            ref="search_10"
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交时间" v-if="type == 2">
                        <el-date-picker
                            ref="search_11"
                            size="small"
                            style="width: 100%"
                            v-model="dateTimes2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            Visible: false,
            customerList: [],
            searchData: {
                Type:2,//类型决定当前页面是调拨配件历史还是调拨计划明细
                InWarehouseId:'',
                OutWarehouseId:'',
                OrderCode:'',
                APCode: '',
                GoodName: '',
                BrandName:[],
                AutoSerise: '',
                Cate: [],
                Remark: '',
                State:0,
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: 15
            },
            dateTimes1:[],
            dateTimes2:[],
            typeList: [],
            tableData: [],
            brandList:[],
            tableDataLength: 0,
            stateList: [
                { Text: '全部', Value: 0 },
                { Text: '已提交', Value: 1 },
                { Text: '已完成', Value: 4 },
            ],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            warehouseList: [],
            cust: [], //客户对象，用于客户搜索
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            searchIndex: 0,
            type:1,
        };
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.searchIndex = 0;
        this.searchData.Type = parseInt(this.$route.query.Type);
        this.type = parseInt(this.$route.query.Type),
        this.getTableData();
        this.$util.setEnterEvent(this, this.$route.fullPath);
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (key === 13) {
                e.preventDefault();
                if (that.Visible) {
                    that.handleSearch();
                }
            }
            if (key === 27) {
                if (
                    (that.$refs.search_1) ||
                    (that.$refs.search_2) ||
                    (that.$refs.search_4) ||
                    (that.$refs.search_5) ||
                    (that.$refs.search_6) ||
                    (that.$refs.search_7) 
                ) {
                    if (that.$refs.search_1) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_2) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_4) that.$refs.search_4.suggestions = [];
                    if (that.$refs.search_5) that.$refs.search_5.suggestions = [];
                    if (that.$refs.search_6) that.$refs.search_7.suggestions = [];
                    if (that.$refs.search_7) that.$refs.search_6.suggestions = [];
                    return;
                }
                e.preventDefault();
                if (that.Visible) that.Visible = false;

            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.Visible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);

                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.Visible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                if (that.Visible) {
                    if (that.searchIndex != 12) {
                        if (that.searchIndex == 1 || that.searchIndex == 2 || that.searchIndex == 4 || that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                        }
                        that.searchIndex += 1;
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                    }
                }
            }
            //上键
            if (key == 38) {
                e.preventDefault();
                if (that.Visible) {
                    if (that.searchIndex != 0) {
                        if (that.searchIndex == 1 || that.searchIndex == 2 || that.searchIndex == 4 || that.searchIndex == 5 || that.searchIndex == 6 || that.searchIndex == 7) {
                            if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                        }
                        that.searchIndex -= 1;
                        if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                    }
                }
            }
        },
        resetSearch() {
            this.searchData = {
                Type:this.type,
                InWarehouseId:'',
                OutWarehouseId:'',
                OrderCode:'',
                APCode: '',
                GoodName: '',
                BrandName:[],
                AutoSerise: '',
                Cate: [],
                Remark: '',
                State:0,
                StartDate: '',
                EndDate: '',
                CStartDate: '',
                CEndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.dateTimes1 = [];
            this.dateTimes2 = [];
            this.cust = '';
        },
        getTableData() {
            let url = '';
            url = '/api/EntpTransferOrder/GetEntpTransGoodsHisList';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        closeSearchDialog_N() {
            this.Visible = false;
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse(1).then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.typeList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.loading = true;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.typeList = [...this.typeList, ...data];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchCate('');
            }
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit)
                .then(data => {
                    this.loading = false;
                    if (!data) return;
                    this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                    this.customerList = this.$util.uniqueArr(this.customerList, data);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        async searchGoodName(key) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                this.goodNameOptions = [...this.goodNameOptions, ...data];
            }
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        async searchAutoSerise(key) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.optionLoading = true;
            const data = await this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit);
            this.optionLoading = false;
            if (data) {
                if (!data) return;
                this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...data];
            }
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },       
        custChange(val) {
            let that = this;
            if (!val) {
                that.searchData.EntpCusId = '';
                that.searchData.EntpCusName = '';
                that.cusForm.key = '';
            } else if (typeof val == 'string') {
                that.searchData.EntpCusId = '';
                that.searchData.EntpCusName = val;
            } else {
                that.searchData.EntpCusId = val.EntpCusId;
                that.searchData.EntpCusName = '';
            }
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                let id = event.EntpCusOId;
                this.$router.push(`/inventoryManage/transWarehouse/edit_v2?type=1&TOId=${id}`);
            }
        },
    }
};
</script>
<style lang="less" scoped>
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 40%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
            margin-right: 10px;
        }
        .el-form-item {
            margin-bottom: 0;
            margin-right: 10px;
            margin-left: 10px;

        }
    }
    .el-dialog__body {
        height: 485px;
        overflow: auto;
    }
    .el-range-editor--small .el-range-separator{
        width: 24px !important;
    }
}    
</style>